import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { toDateParseTCompact, toDateTimeCompact } from "../../utils/datesHeures";

import { apiGetProcesses } from "../../api/ApiProcess";
import { apiGetEmissions } from "../../api/ApiEmission";
import { apiGetPublications } from "../../api/ApiPublication";
import {
  apiGetLastContribsOnEspacesColidee,
  apiRecupActualitesColidee,
  apiRecupGaleriesColidee,
} from "../../api/ApiColidee";
import ComponentContribution from "../../components/public/colidee/ComponentContribution";
import BlocActualitesThumbnail from "../../components/public/colidee/BlocActualitesThumbnail";
import ComponentEmissionsThumbnail from "../../components/public/media/ComponentEmissionsThumbnail";
import BlocPublicationsThumbnail from "../../components/public/media/BlocPublicationsThumbnail";
import ComponentLoader from "../../components/layout/ComponentLoader";
import { selectInViewsFilters } from "../../redux/ReduxFilter";

const ContainerInviewsCalendar = (props) => {
  const { anteriorite } = props;
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxToken } = useSelector((state) => state.ReduxToken);
  const [datas, setDatas] = useState([]);
  const [loader, setLoader] = useState(false);
  const [alldatas, setAllDatas] = useState([]);
  const _selectInViewFilters = useSelector(selectInViewsFilters);

  /* Recup des idées sur Colidée */
  const recupGlobal = async () => {
    setLoader(true);
    var espacesSouhaites = [];
    var retour = [];
    const form = new FormData();

    const resProcesses = await apiGetProcesses(ReduxInstance._id, "filter[famille]=MacroProcess");
    resProcesses.data.map(
      (process) => (espacesSouhaites = espacesSouhaites.concat(process.espaces)),
    );
    espacesSouhaites = espacesSouhaites.filter((x, i, a) => a.indexOf(x) === i);
    form.append("espacesSouhaites", espacesSouhaites.join(","));
    form.append("entreprises", ReduxInstance.entreprisesColidee.join(","));

    /* recup Idées du moment COLIDEE */
    const resColideeIdees = await apiGetLastContribsOnEspacesColidee(ReduxToken, form);
    /* recup Actualites COLIDEE */
    const resColideeActualites = await apiRecupActualitesColidee(ReduxToken, form);
    /* recup Galeries COLIDEE */
    const resColideeGaleries = await apiRecupGaleriesColidee(ReduxToken, form);
    /* recup Emissions EASYGOUV */
    const resEmissions = await apiGetEmissions(
      ReduxInstance._id,
      "filter[publie]=true&filter[datePublication][$exists]=true",
    );
    /* recup Publications EASYGOUV */
    const resPublications = await apiGetPublications(
      ReduxInstance._id,
      "filter[publie]=true&filter[datePublication][$exists]=true",
    );

    retour.idees = resColideeIdees.data;
    retour.actualites = resColideeActualites.data;
    retour.emissions = resEmissions.data;
    retour.publications = resPublications.data;
    retour.galeries = resColideeGaleries.data;

    setAllDatas(retour);
    setLoader(false);
  };

  const filtreDatas = async () => {
    var now = new Date();
    // on calcule la date UNIX 30 jours avant
    var nomMoinsAnteriorite = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - anteriorite,
    );
    /* oni calcule la date de l'anteriorite pour pouvoir la comparer à la date de l'event et à la date d'embauche */
    var dateAnteriorite =
      nomMoinsAnteriorite.getFullYear() +
      "" +
      ("0" + (nomMoinsAnteriorite.getMonth() + 1)).slice(-2) +
      "" +
      ("0" + nomMoinsAnteriorite.getDate()).slice(-2);

    var classement = [];

    /* on parcours les idées pour en déterminer la date de publication */
    if (alldatas.idees) {
      alldatas.idees.forEach((item) => {
        if (item.datePublication && toDateParseTCompact(item.datePublication) >= dateAnteriorite) {
          classement.push({
            date: toDateTimeCompact(item.datePublication),
            type: "idee",
            data: item,
          });
        }
      });
    }

    if (alldatas.actualites) {
      alldatas.actualites.forEach((item) => {
        if (
          item.date_publication &&
          toDateParseTCompact(item.date_publication) >= dateAnteriorite
        ) {
          classement.push({
            date: toDateTimeCompact(item.date_publication),
            type: "actualite",
            data: item,
          });
        }
      });
    }

    if (alldatas.emissions) {
      alldatas.emissions.forEach((item) => {
        if (item.datePublication && toDateParseTCompact(item.datePublication) >= dateAnteriorite) {
          classement.push({
            date: toDateParseTCompact(item.datePublication),
            type: "emission",
            data: item,
          });
        }
      });
    }

    if (alldatas.publications) {
      alldatas.publications.forEach((item) => {
        if (item.datePublication && toDateParseTCompact(item.datePublication) >= dateAnteriorite) {
          classement.push({
            date: toDateParseTCompact(item.datePublication),
            type: "publication",
            data: item,
          });
        }
      });
    }

    classement.sort((b, a) => (a.date > b.date ? 1 : b.date > a.date ? -1 : 0));
    setDatas(classement);
  };

  const renderItem = (objet, index) => {
    if (objet.type === "idee" && (_selectInViewFilters.idee || _selectInViewFilters.all)) {
      return (
        <React.Fragment key={index}>
          <ComponentContribution contributionObject={objet.data} />
        </React.Fragment>
      );
    }

    if (
      objet.type === "actualite" &&
      (_selectInViewFilters.actualite || _selectInViewFilters.all) &&
      ReduxInstance.modulesActives.includes("actualite")
    ) {
      return (
        <React.Fragment key={index}>
          <BlocActualitesThumbnail actualiteObject={objet.data} />
        </React.Fragment>
      );
    }

    if (
      objet.type === "emission" &&
      (_selectInViewFilters.emission || _selectInViewFilters.all) &&
      ReduxInstance.modulesActives.includes("emission")
    ) {
      return (
        <React.Fragment key={index}>
          <ComponentEmissionsThumbnail emissionObject={objet.data} />
        </React.Fragment>
      );
    }

    if (
      objet.type === "publication" &&
      (_selectInViewFilters.publication || _selectInViewFilters.all) &&
      ReduxInstance.modulesActives.includes("publication")
    ) {
      return (
        <React.Fragment key={index}>
          <BlocPublicationsThumbnail publicationObject={objet.data} />
        </React.Fragment>
      );
    }
  };

  useEffect(() => {
    filtreDatas();
  }, [ReduxInstance, anteriorite, loader]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    recupGlobal();
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {loader && (
        <div className="text-center">
          <ComponentLoader />
        </div>
      )}
      {!loader && (
        <div className="d-flex flex-wrap align-items-stretch justify-content-center justify-content-md-start">
          {datas.map((objet, index) => renderItem(objet, index))}
        </div>
      )}
    </>
  );
};

export default ContainerInviewsCalendar;
